import { BEGIN_LOGGING_TEXT, END_LOGGING_TEXT } from './decoratorUtils';
/** Function to execute synchronous callbacks while also logging callback start and end. */
export function logVerbose(logger, functionName, callback) {
    logger.logVerbose(functionName, `${BEGIN_LOGGING_TEXT}: ${functionName}`);
    try {
        return callback();
    }
    finally {
        logger.logVerbose(functionName, `${END_LOGGING_TEXT}: ${functionName}`);
    }
}
/** Function to execute asynchronous callbacks while also logging callback start and end. */
export async function logVerboseAsync(logger, functionName, callback) {
    logger.logVerbose(functionName, BEGIN_LOGGING_TEXT);
    return callback()
        .then((result) => {
        return result;
    })
        .finally(() => logger.logVerbose(functionName, END_LOGGING_TEXT));
}
//# sourceMappingURL=logVerboseWrappers.js.map